import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=7287cd0d&"
import script from "./OrderTable.vue?vue&type=script&lang=js&"
export * from "./OrderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7287cd0d')) {
      api.createRecord('7287cd0d', component.options)
    } else {
      api.reload('7287cd0d', component.options)
    }
    module.hot.accept("./OrderTable.vue?vue&type=template&id=7287cd0d&", function () {
      api.rerender('7287cd0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/reports/OrderTable.vue"
export default component.exports